/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateGrantResources} from '../models/UpdateGrantResources';
import type {UpdateGrantResourcesResult} from '../models/UpdateGrantResourcesResult';

export interface BulkDischargeGrantResources$Request {
    updateGrantResources: UpdateGrantResources;
    reason?: string;
}

export interface BulkDischargeGrantResources$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkDischargeGrantResourcesRequest = createAction<PayloadData<void, BulkDischargeGrantResources$Request>>('BULK_DISCHARGE_GRANT_RESOURCES__BULK_DISCHARGE_GRANT_RESOURCES__REQUEST');
export const bulkDischargeGrantResourcesSuccess = createAction<PayloadData<string, BulkDischargeGrantResources$Request>>('BULK_DISCHARGE_GRANT_RESOURCES__BULK_DISCHARGE_GRANT_RESOURCES__SUCCESS');
export const bulkDischargeGrantResourcesFailure = createAction<PayloadData<Error, BulkDischargeGrantResources$Request, true>>('BULK_DISCHARGE_GRANT_RESOURCES__BULK_DISCHARGE_GRANT_RESOURCES__FAILURE');

export const bulkDischargeGrantResourcesActions = [
    bulkDischargeGrantResourcesRequest,
    bulkDischargeGrantResourcesSuccess,
    bulkDischargeGrantResourcesFailure
] as const;

/**
 * @param {UpdateGrantResources} meta.updateGrantResources
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkDischargeGrantResources = (meta: BulkDischargeGrantResources$Request, config?: BulkDischargeGrantResources$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: bulkDischargeGrantResourcesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/bulk-actions/grants/discharge-resouces`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateGrantResources,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface BulkDischargeGrantResourcesProgress$Request {
    id: string;
}

export interface BulkDischargeGrantResourcesProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkDischargeGrantResourcesProgressRequest = createAction<PayloadData<void, BulkDischargeGrantResourcesProgress$Request>>('BULK_DISCHARGE_GRANT_RESOURCES__BULK_DISCHARGE_GRANT_RESOURCES_PROGRESS__REQUEST');
export const bulkDischargeGrantResourcesProgressSuccess = createAction<PayloadData<BulkProgress, BulkDischargeGrantResourcesProgress$Request>>('BULK_DISCHARGE_GRANT_RESOURCES__BULK_DISCHARGE_GRANT_RESOURCES_PROGRESS__SUCCESS');
export const bulkDischargeGrantResourcesProgressFailure = createAction<PayloadData<Error, BulkDischargeGrantResourcesProgress$Request, true>>('BULK_DISCHARGE_GRANT_RESOURCES__BULK_DISCHARGE_GRANT_RESOURCES_PROGRESS__FAILURE');

export const bulkDischargeGrantResourcesProgressActions = [
    bulkDischargeGrantResourcesProgressRequest,
    bulkDischargeGrantResourcesProgressSuccess,
    bulkDischargeGrantResourcesProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkDischargeGrantResourcesProgress = (meta: BulkDischargeGrantResourcesProgress$Request, config?: BulkDischargeGrantResourcesProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: bulkDischargeGrantResourcesProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/grants/discharge-resouces/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDischargeGrantResourcesResult$Request {
    id: string;
}

export interface GetDischargeGrantResourcesResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDischargeGrantResourcesResultRequest = createAction<PayloadData<void, GetDischargeGrantResourcesResult$Request>>('BULK_DISCHARGE_GRANT_RESOURCES__GET_DISCHARGE_GRANT_RESOURCES_RESULT__REQUEST');
export const getDischargeGrantResourcesResultSuccess = createAction<PayloadData<UpdateGrantResourcesResult, GetDischargeGrantResourcesResult$Request>>('BULK_DISCHARGE_GRANT_RESOURCES__GET_DISCHARGE_GRANT_RESOURCES_RESULT__SUCCESS');
export const getDischargeGrantResourcesResultFailure = createAction<PayloadData<Error, GetDischargeGrantResourcesResult$Request, true>>('BULK_DISCHARGE_GRANT_RESOURCES__GET_DISCHARGE_GRANT_RESOURCES_RESULT__FAILURE');

export const getDischargeGrantResourcesResultActions = [
    getDischargeGrantResourcesResultRequest,
    getDischargeGrantResourcesResultSuccess,
    getDischargeGrantResourcesResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDischargeGrantResourcesResult = (meta: GetDischargeGrantResourcesResult$Request, config?: GetDischargeGrantResourcesResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getDischargeGrantResourcesResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/grants/discharge-resouces`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

